module.exports = __webpack_public_path__ + "assets/img/bp_d_i_11.fa4bcb07.jpg";